export default __webpack_public_path__ + "static/media/4 - Информационные стенды о животных.eaaad66a.jpeg";